import { some } from "./constants";

export const stringifyUrl = function (obj) {
  var str: string[] = [];
  for (const p in obj) {
    const value = obj[p];
    if (obj.hasOwnProperty(p) && value) {
      str.push(
        encodeURIComponent(p) +
          "=" +
          encodeURIComponent(
            typeof value === "object"
              ? JSON.stringify(value)
              : typeof value === "string" || typeof value === "number"
              ? value
              : ""
          )
      );
    }
  }
  return str.join("&");
};

export function capitalizeFirstLetter(string = "") {
  return string?.charAt(0).toUpperCase() + string?.slice(1);
}

export function scrollTo(id: string, offsetTop: number) {
  const el = document.getElementById(id);
  if (el) {
    window.scrollTo({ top: el.offsetTop - offsetTop, behavior: "smooth" });
  }
}

export function mappedFilter(filter?: some) {
  if (!filter) {
    return {};
  }
  return Object.keys(filter).reduce((value, key) => {
    const tmp = filter[key];

    if (tmp?.id) {
      return {
        ...value,
        [key]: tmp.id,
      };
    }
    if (key === "date") {
      return {
        ...value,
        ...tmp,
      };
    }
    if (tmp !== null || tmp !== undefined) {
      return {
        ...value,
        [key]: tmp,
      };
    }
    return value;
  }, {});
}

export function removeAccent(str: string): string {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  return str;
}
